module.exports = __webpack_public_path__ + "0f8492b73a8ac14a5271079f553779e7.pdf";